import { Chip } from "@mui/material"

const ColorChip = ({ label, color, ...rest }) => {
    const [r, g, b] = color
    return (
        <Chip label={label} className={rest?.className} style={{
            textTransform: 'capitalize',
            backgroundColor: `rgba(${r},${g},${b}, 1)`,
            padding: 10,
        }} sx={{
            "& .MuiChip-label": {
                color: `rgb(255,255,255)`,
                fontWeight: 500,
                fontSize: 12,
            }
        }} />
    )
}

export default ColorChip